module.exports = __webpack_public_path__ + "img/quickmenu_en.f896288.jpg";